import { create } from 'zustand';

interface LoginState {
  email: string;

  setEmail: (email: string) => void;
}

export const useLoginStore = create<LoginState>((set) => ({
  email: '',
  setEmail: (email) => set({ email }),
}));
